import * as React from "react";
import { useContext } from "react";
import { RunnerContext } from "../../context/RunnerContext";
import { DashboardCard } from "./DashboardCard";

export const Dashboard = () => {
  const { runner } = useContext(RunnerContext);

  return (
    <div className="w-full h-full flex gap-6 flex-col justify-start p-6">
      <div className="text-3xl font-bold dark:text-white">
        Welcome back, {runner?.runnerName}!
      </div>
      <div className="w-full flex flex-row gap-2 flex-wrap">
        <DashboardCard
          title={"Total Kilometers"}
          mainContent={"42 km"}
          additionalContent={"+20.1% from last month"}
        />
        <DashboardCard
          title={"Best Pace"}
          mainContent={"04:30"}
          additionalContent={"per kilometer"}
        />
        <DashboardCard
          title={"Average Pace"}
          mainContent={"05:10"}
          additionalContent={"per kilometer"}
        />
      </div>
    </div>
  );
};
